import { FilterField } from "kontrolEdge/helpers/advancedFilters";
import { carriersAdminText } from "./carriersLabels";
import { CarrierRow } from "./CarriersData";

const text = carriersAdminText;

/** Searchbar fields of the Carriers table; labels match the column headers. */
export function makeCarrierFields(): FilterField<CarrierRow>[] {
  return [
    { label: text.columns.name, key: "name", accessor: (r) => r.name, inFreeText: true },
    { label: text.columns.code, key: "code", accessor: (r) => r.codeLabel, inFreeText: true },
    {
      label: text.columns.available,
      key: "available",
      // Searched by the word the tag shows.
      accessor: (r) => (r.available ? text.available.yes : text.available.no),
    },
    {
      label: text.columns.services,
      key: "services",
      accessor: (r) => r.serviceCount,
      type: "number",
    },
  ];
}
